export const defaultLogo = "https://cdn.simulanis.io/sso/logos/default_simulanis.png";
export const applicationId = "f6547169-f819-4ca9-a5dd-01d7abdc1c30";
export const UNO_URL = "https://api.simulanis.io";
// export const UNO_URL = "https://simulanis-uno-backend-backup-uat.azurewebsites.net";
